module.exports = __webpack_public_path__ + "img/dev03.f59a9213.jpg";